import { render, staticRenderFns } from "./CooperationUsersDialog.vue?vue&type=template&id=36218dc9&scoped=true&"
import script from "./CooperationUsersDialog.vue?vue&type=script&lang=js&"
export * from "./CooperationUsersDialog.vue?vue&type=script&lang=js&"
import style0 from "./CooperationUsersDialog.vue?vue&type=style&index=0&id=36218dc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36218dc9",
  null
  
)

export default component.exports